import { AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import { useContextHeaders } from 'hooks/useContextHeaders';
import {
  deleteSuppressedEmailApi,
  DeleteSuppressedEmailParams,
  DeleteSuppressedEmailResponse,
} from 'AwsModule/api/deleteSuppressedEmailApi';
import { awsSuppressedEmailsQueryKeys } from 'AwsModule/query/awsQueryKeys';

export const useDeleteSuppressedEmailMutation = () => {
  const token = useSelector(selectAuthToken);
  const queryClient = useQueryClient();
  const { buildConfig } = useContextHeaders();

  const mutation = useMutation<
    AxiosResponse<DeleteSuppressedEmailResponse>,
    AxiosResponse<unknown>,
    DeleteSuppressedEmailParams
  >({
    mutationFn: async (params) => {
      if (!token) throw new Error('No auth token available');
      return deleteSuppressedEmailApi({
        params,
        token,
        config: buildConfig(),
      }) as Promise<AxiosResponse<DeleteSuppressedEmailResponse>>;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: awsSuppressedEmailsQueryKeys.listInvalidation({
          identifier: 'useListSuppressedEmailsQuery',
        }),
      });
    },
  });

  return {
    deleteSuppressedEmail: mutation.mutate,
    deleteSuppressedEmailAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
  };
};
